import { withStyles } from '@material-ui/core';
import { compose } from 'ramda';

import withSelection from '@/hocs/withSelection';

import CommonTable from './component';
import styles from './styles';

export default compose(withSelection, withStyles(styles))(CommonTable);
